import { createStore  } from 'redux'
import { reducer, ItemState } from './reducers'

export type AppState = {
    items: ItemState[]
}

const store = createStore(reducer);

export default store;